import { ApolloError } from '@apollo/client'
import { Alert, alpha, Box, Typography } from '@mui/material'
import React from 'react'
import PwsSpinner from '../../../../../components/loader/PwsSpinner'
import { useAppTranslations } from '../../../../../utils/hooks/useAppTranslations'
import { useAdgroupContext } from '../../../../../utils/hooks/adGroup/useAdgroupContext'
import { BudgetHistoryCostChart } from './BudgetHistoryCostChart'
import { AdGroupBudgetHistoryEntry } from './budgetHistoryTypes'

type BudgetHistoryContentProps = {
  changes: AdGroupBudgetHistoryEntry[]
  loading: boolean
  error: ApolloError | undefined
  dense?: boolean
}

export const BudgetHistoryContent: React.FC<BudgetHistoryContentProps> = ({
  changes,
  loading,
  error,
  dense = false,
}) => {
  const t = useAppTranslations()
  const [adGroup] = useAdgroupContext()
  const chartFallbacks = {
    costValue: adGroup.costValue ?? null,
    costType: adGroup.costType,
    dailyBudget: adGroup.dailyBudget ?? null,
    budgetCapping: adGroup.budgetCapping ?? null,
    dailyBudgetType: adGroup.dailyBudgetType,
    budgetCappingType: adGroup.budgetCappingType,
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Typography variant="subtitle1" component="h2" sx={{ mb: 1, fontWeight: 600 }}>
        {t('adgroup.spentBudget.history.title')}
      </Typography>
      <Box sx={{ mx: -2, width: 'calc(100% + 32px)', minWidth: 0, overflow: 'visible' }}>
        <BudgetHistoryCostChart changes={changes} fallbacks={chartFallbacks} dense={dense} />
      </Box>
      {error ? <Alert severity="error">{error.message}</Alert> : null}
      {loading ? (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: (theme) => alpha(theme.palette.background.paper, 0.6),
          }}
        >
          <PwsSpinner />
        </Box>
      ) : null}
    </Box>
  )
}
